let $ = jQuery;

class Accessibility {

  constructor() {
    // jQuery formatted selector to search for focusable items
    this.focusableElementsString = "a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, embed, *[tabindex], *[contenteditable]";
  }

  /*
    Loops through a wrapper - for each focusable elements in that wrapper
    set tabindex to 0 otherwise set to -1 or 0, based on a class applied to the wrapper.
    $wrapper is a jquery object representing the parent.
    activeState is a string that says what the activeState to test against is.
    $focusItem is a jquery object representing the objec to focus on.
  */
  toggleTabbing($wrapper, activeState, $focusItem) {
    var tabindex = $wrapper.hasClass(activeState) ? 0 : -1;
    var children = $wrapper.find('*');

    // get list of focusable items
    var focusableItems = children.filter(this.focusableElementsString);

    $.each(focusableItems, (index, elem) => {
      $(elem).attr('tabindex', tabindex);
    });

    if ($focusItem) {
      $focusItem.focus();
    }
  }
}

let accessibility = new Accessibility;
module.exports = accessibility;
